import React from 'react';
const rows = [['100+ unpaid hours a year writing plans', '10 minutes the night before'], ['Improvised practices with no progression', '300+ pages, sequenced by level'], ['Athletes standing around', 'Stations so everyone is working'], ['Stunts that drop at comp', 'Full-out blocks with music'], ['Nothing to show a parent', 'Scorecards and documentation']];
export function CostOfInaction() {
  return <section className="w-full bg-navy-deep" data-id="element-55" data-mp="34uyttoyt4ca5">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-56" data-mp="34u74uwzptcsu">
        <h2 className="text-center font-display font-bold uppercase text-white text-3xl sm:text-4xl" data-id="element-57" data-mp="38wahhoy4enfp">
          What another improvised season costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-navy-line" data-id="element-58" data-mp="3iny4ndnn9ibd">
          <div className="grid grid-cols-2 bg-navy-mid text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-59" data-mp="3nmrk3bmhrje6">
            <div className="border-r border-navy-line px-3 py-2.5 text-crimson-soft" data-id="element-60" data-mp="3skt2rvg09gp4">
              Without the system
            </div>
            <div className="px-3 py-2.5 text-gold" data-id="element-61" data-mp="3ei12psiah1pb">With Cheer Coach Pro</div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-navy-line text-[12.5px] sm:text-sm" data-id="element-62" data-mp="34iaaxyl450sx">
              <div className="border-r border-navy-line px-3.5 py-3.5 text-white/60 line-through decoration-crimson/50" data-id="element-63" data-mp="30i046jphy6d0">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-64" data-mp="3s84nsg5fmpd6">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}